export const I18N_NAMESPACE = "l2r-app-safety"